import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const appointmentTypesRoutes: Routes = [
  {
    path: 'appointment-types',
    title: 'Terminarten',
    loadComponent: () =>
      import('./appointment-types-list/appointment-types-list').then(
        m => m.AppointmentTypesListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'appointment-types/new',
    title: 'Neue Terminart',
    loadComponent: () =>
      import('./appointment-type-form/appointment-type-form').then(
        m => m.AppointmentTypeFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'appointment-types/:id/edit',
    title: 'Terminart bearbeiten',
    loadComponent: () =>
      import('./appointment-type-form/appointment-type-form').then(
        m => m.AppointmentTypeFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
